<div mat-dialog-content>
    <div class="select-list">
        <div *ngFor="let group of groups">
            <mat-checkbox [(ngModel)]="group.selected">
                {{ group.title[currentLanguage] }}
            </mat-checkbox>
            <mat-icon (click)="addOrUpdateGroup(group._id)">mode_edit</mat-icon>
            <mat-icon *ngIf="!group.notDeletable" (click)="removeGroup(group._id)">remove_circle_outline</mat-icon>
        </div>
    </div>
</div>
<div mat-dialog-actions class="list-action-buttons">
    <div class="add-button">
        {{ 'aumico_templates_group_list_new_group' | i18next }}
        <mat-icon (click)="addOrUpdateGroup()">add_circle_outline</mat-icon>
    </div>
    <div>
        <aumico-button (click)="save()" id="save-button">{{ 'aumico_templates_save' | i18next }}</aumico-button>
        <aumico-button (click)="closeDialog()" id="cancel-button">{{
            'aumico_templates_cancel' | i18next
        }}</aumico-button>
    </div>
</div>
